module.exports = __webpack_public_path__ + "static/media/thumb-down-svgrepo-com.54434c13.svg";